import {RequestIdentity} from '../models/RequestIdentity';

/** Строковое представление RequestIdentity **/
export const requestIdentityToString = (requestIdentity: RequestIdentity): string =>
  `${requestIdentity.configName}/${requestIdentity.id}/${requestIdentity.type}`;
